import api from '../token';

export const ListConta = async () => {
  try {
    const response = await api.post('/getConta');
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar produtos:', error);
    return [];
  }
};

